module.exports = __webpack_public_path__ + "media/assets/images/curation/good-84d4b90510d68dbbda6c562ad6e3eb0c.svg";